import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useFakeToggleState } from '../../../utils/hooks/useFakeToggleState';
import Toggle from './Toggle';
import TextTooltipOnHover from '../../../Tooltip/TextTooltipOnHover';
import s from './VersionToggle.scss';
export var VersionToggle = function (_a) {
    var onToggle = _a.onToggle, className = _a.className;
    var t = useTranslation().t;
    var _b = useFakeToggleState(true, onToggle), onClick = _b.onClick, toggleState = _b.toggleState;
    return (React.createElement("div", { className: s['root'], onClick: onClick },
        React.createElement(TextTooltipOnHover, { placement: "bottom", className: classnames(s['switch'], className), tooltipText: t('siteHeader.userMenu.switchVersion'), renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: s['label'] }, "Eclipse"),
                    React.createElement(Toggle, { enabled: toggleState, className: s['toggle'], containerRef: ref })));
            } })));
};
VersionToggle.displayName = 'VersionToggle';
export default VersionToggle;
//# sourceMappingURL=VersionToggle.js.map